import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

import { mockFooterLinks } from './mock';

type FooterProps = {
  links?: Array<{ link: string; icon: ReactNode }>;
};

export const Footer: FC<FooterProps> = ({ links = mockFooterLinks }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Container sx={{ py: 2 }}>
      <Stack
        direction={isLargeScreen ? 'row' : 'column'}
        {...(isLargeScreen ? { justifyContent: 'space-between' } : { spacing: 1, alignItems: 'center' })}
      >
        {isLargeScreen ? (
          <>
            <Typography>Mogul Productions © All rights Reserved</Typography>
            <Stack direction="row" spacing={2}>
              {links.map(({ link, icon }) => (
                <NavLink to={link} key={link}>
                  {icon}
                </NavLink>
              ))}
            </Stack>
          </>
        ) : (
          <>
            <Stack direction="row" spacing={2}>
              {links.map(({ link, icon }) => (
                <NavLink to={link} key={link}>
                  {icon}
                </NavLink>
              ))}
            </Stack>
            <Typography>Mogul Productions © All rights Reserved</Typography>
          </>
        )}

        <Stack direction="row" spacing={1} sx={{ width: 282 }}>
          <NavLink to="https://www.mogulproductions.com/terms-conditions/">
            <Typography sx={{ textDecoration: 'underline' }}>Terms & Conditions</Typography>
          </NavLink>
          <NavLink to="https://www.mogulproductions.com/privacy-policy/">
            <Typography sx={{ textDecoration: 'underline' }}>Privacy Policy</Typography>
          </NavLink>
        </Stack>
      </Stack>
    </Container>
  );
};
